import Vuex, { Store } from 'vuex';
import { IQuoteState } from '@/store/quote/quote.state';
import { quoteActions } from '@/store/quote/quote.actions';
import { quoteMutations } from '@/store/quote/quote.mutations';

export let quoteStore: Store<IQuoteState>;

export function initializeQuoteStore() {
    quoteStore = new Vuex.Store<IQuoteState>({
        state: {
            attachments: [],
            attachmentBudgetBytes: null,
            quoteUsers: [],
            selectedClient: null,
        },
        actions: quoteActions,
        mutations: quoteMutations,
    });
    return quoteStore;
}
